import {
  enquiryFormToggle,
  fetchEnquiryConfirmationSupplier,
  fetchEnquiryConfirmationSupplierSuccess,
  fetchEnquiryDates,
  fetchEnquiryDatesSuccess,
  openVenueConfirmationPopup,
  resetEnquiryForm,
  sendEnquirySuccess,
  setEnquirySupplier,
  clearPlannerEnquiryResult,
  setInfoProps,
  setPlannerEnquiryResult,
  showEnquiriesUserLimitModal,
  toggleEnquiryConfirmationScreen,
  toggleMultipleEnquiry,
} from '@bridebook/web/lib/enquiries/actions';

export enum EnquiriesActionTypes {
  CONFIRM_ENQUIRY_FORM_ERROR = '[Enquiries] confirm enquiry error',
  ENQUIRY_FORM_TOGGLE = '[Enquiries] Enquiry form toggle',
  FETCH_ENQUIRY_CONFIRMATION_SUPPLIER_START = '[Enquiries] Fetch enquiry confirmation supplier start',
  FETCH_ENQUIRY_CONFIRMATION_SUPPLIER_SUCCESS = '[Enquiries] Fetch enquiry confirmation supplier FS success',
  ON_SUPPLIER_ENQUIRY_INTERACT_ANALYTICS = '[Analytics] [Enquiries] On supplier enquiry interact',
  RESET_ENQUIRY_FORM = '[Enquiries] Reset enquiry form',
  UPDATE_WEDDING_WITH_ENQUIRY_FIELDS_ERROR = '[Enquiries] Update wedding with enquiry fields error',
  UPDATE_WEDDING_WITH_ENQUIRY_FIELDS_START = '[Enquiries] Update wedding with enquiry fields start',
  UPDATE_WEDDING_WITH_ENQUIRY_FIELDS_SUCCESS = '[Enquiries] Update wedding with enquiry fields success',
  SEND_ENQUIRY_ERROR = '[Enquiries] Send enquiry error',
  SEND_ENQUIRY_SUCCESS = '[Enquiries] Send enquiry success',
  SEND_ENQUIRY_SUCCESS_ANALYTICS = '[Enquiries][Analytics] Send enquiry success analytics',
  SET_ENQUIRY_SUPPLIER = '[Enquiries] Set enquiry supplier',
  TOGGLE_ENQUIRY_CONFIRMATION = '[Enquiries] Toggle enquiry confirmation',
  TOGGLE_ENQUIRY_CONFIRMATION_SCREEN = '[Enquiries] Toggle enquiry confirmation screen',
  FETCH_ENQUIRY_DATES = '[Enquiries] Fetch enquiry dates',
  FETCH_ENQUIRY_DATES_SUCCESS = '[Enquiries] Fetch enquiry dates success',
  SHOW_ENQUIRIES_USER_LIMIT_MODAL = '[Enquiries] Show enquiries user limit modal',
  TOGGLE_MULTIPLE_ENQUIRY = '[Enquiries] Toggle multiple enquiries',
  OPEN_CONFIRMATION_MODAL = '[Enquiries] Open venue confirmation popup',
  SET_LOGGED_OUT_ENQUIRY_TRIGGERED = '[Enquiries] Set logged out enquiry triggered',
  SET_INFO_PROPS = '[Enquiries] Set info props',
  SET_PLANNER_ENQUIRY_RESULT = '[Enquiries] Set planner enquiry result',
  CLEAR_PLANNER_ENQUIRY_RESULT = '[Enquiries] Clear planner enquiry result',
}

export type IFetchEnquiryConfirmationSupplier = ReturnType<typeof fetchEnquiryConfirmationSupplier>;

export type ISendEnquirySuccessAction = ReturnType<ReturnType<typeof sendEnquirySuccess>>;

export type IToggleEnquiryConfirmationScreenAction = ReturnType<
  typeof toggleEnquiryConfirmationScreen
>;

export type ISetEnquirySupplierAction = ReturnType<typeof setEnquirySupplier>;

export type IEnquiryFormToggleAction = ReturnType<ReturnType<typeof enquiryFormToggle>>;

export type IResetEnquiryFormAction = ReturnType<ReturnType<typeof resetEnquiryForm>>;

export type IFetchEnquiryConfirmationSupplierSuccessAction = ReturnType<
  ReturnType<typeof fetchEnquiryConfirmationSupplierSuccess>
>;

export type IFetchEnquiryDates = ReturnType<typeof fetchEnquiryDates>;

export type IFetchEnquiryDatesSuccess = ReturnType<typeof fetchEnquiryDatesSuccess>;

export type IShowEnquiriesUserLimitModalAction = ReturnType<typeof showEnquiriesUserLimitModal>;

export type IToggleMultipleEnquiry = ReturnType<typeof toggleMultipleEnquiry>;

export type IOpenVenueConfirmationPopup = ReturnType<typeof openVenueConfirmationPopup>;

export type IEnquirySetInfoProps = ReturnType<typeof setInfoProps>;

export type ISetPlannerEnquiryResult = ReturnType<typeof setPlannerEnquiryResult>;

export type IClearPlannerEnquiryResult = ReturnType<typeof clearPlannerEnquiryResult>;
